import DataGrid, {
  Column,
  Pager,
  Paging,
  SearchPanel,
  Summary,
  TotalItem,
  Selection,
} from "devextreme-react/data-grid";
import React, { useState, useCallback } from "react";
import { Button, Modal } from "react-bootstrap";

interface ProductSelectionModalProps {
  show: boolean;
  onHide: () => void;
  products: any[];
  onSelectProduct: (product: any) => void;
  onSelectMultipleProducts?: (products: any[]) => void;
  loading: boolean;
  searchType: "bagNo" | "styleNo" | "igiNo" | "huid";
}

export const ProductSelectionModal: React.FC<ProductSelectionModalProps> = ({
  show,
  onHide,
  products,
  onSelectProduct,
  onSelectMultipleProducts,
  loading,
  searchType,
}) => {
  const [selectedProductKeys, setSelectedProductKeys] = useState<any[]>([]);
  const [selectedMetalKtIds, setSelectedMetalKtIds] = useState<number[]>([]);


  // Note: handleProductSelect and handleModalHide are kept for potential future use
  // const handleProductSelect = (product: any) => {
  //   onSelectProduct(product);
  //   setSelectedProductKeys([]);
  //   onHide();
  // };

  // const handleModalHide = useCallback(() => {
  //   setSelectedProductKeys([]);
  //   onHide();
  // }, [onHide]);

  const handleSelectionChanged = useCallback((e: any) => {
    setSelectedProductKeys(e.selectedRowKeys);
  }, []);

  const handleAddSelectedProducts = useCallback(() => {
    const selectedProducts = products.filter(product => 
      selectedProductKeys.includes(product.id)
    );
    if (selectedProducts.length > 0 && onSelectMultipleProducts) {
      onSelectMultipleProducts(selectedProducts);
      setSelectedProductKeys([]);
      onHide();
    }
  }, [selectedProductKeys, products, onSelectMultipleProducts, onHide]);

  const getSearchTypeLabel = () => {
    switch (searchType) {
      case "bagNo":
        return "Bag No";
      case "styleNo":
        return "Style No";
      case "igiNo":
        return "IGI No";
      case "huid":
        return "HUID";
      default:
        return "Product";
    }
  };

  // const getPrimaryValue = (product: any) => {
  //   switch (searchType) {
  //     case "bagNo":
  //       return product.bagNo;
  //     case "styleNo":
  //       return product.styleNo;
  //     case "igiNo":
  //       return product.igiNo;
  //     case "huid":
  //       return product.huidNo;
  //     default:
  //       return product.bagNo;
  //   }
  // };
  

//   const handleSelectMultipleProducts = (selectedProducts: any[]) => {
//   const selectedMetalKtIds = selectedProducts.map(p => p.metalKtId); // ✅ extract ids
//   setSelectedMetalKtIds(selectedMetalKtIds); // save to state
//   setShowProductModal(false); // close modal
// };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Product - Multiple Results Found</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2 text-muted">Loading product details...</p>
          </div>
        ) : (
          <>
            <p className="text-muted mb-3">
              Multiple products found for the selected {getSearchTypeLabel()}.
              Use checkboxes to select multiple products or click "Select" for individual items:
            </p>
            <div
              className="table-responsive"
              style={{  overflowY: "auto" }}
            >
              <DataGrid
                dataSource={products}
                remoteOperations={{ groupPaging: true }}
                showRowLines={true}
                keyExpr="id"
                showBorders={true}
                selectedRowKeys={selectedProductKeys}
                onSelectionChanged={handleSelectionChanged}
              >
                <Selection mode="multiple" showCheckBoxesMode="always" />
                <Pager
                  visible={true}
                  showPageSizeSelector={true}
                  showNavigationButtons={true}
                  displayMode="full"
                  showInfo={true}
                />
                <Summary>
                  <TotalItem 
                  // column="Sr.No." summaryType="count" displayFormat="Total : {0}"
                   />
                </Summary>
                <Paging defaultPageSize={10} />
                <SearchPanel visible width={240} placeholder="Search..." />

                <Column
                  caption="Sr.No."
                  dataType="number"
                  alignment="center"
                  cellRender={(e) => {
                    const rowIndex =
                      e.rowIndex +
                      1 +
                      e.component.pageIndex() * e.component.pageSize();
                    return <span>{rowIndex}</span>;
                  }}
                  width={100}
                />
                <Column dataField="bagNo" caption="Bag No" dataType="string" />
                <Column dataField="styleNo" caption="Style No" dataType="string" />
                <Column dataField="categoryName" caption="Category" dataType="string" />
                <Column dataField="netWt" caption="Net Wt" dataType="string" />
                <Column dataField="karatType" caption="Metal Kt" dataType="string"                  />
                <Column dataField="mrpPrice" caption="MRP" dataType="string" format="#,##0.00"  />
                {/* <Column
                  dataField="action"
                  caption="Action"
                  dataType="string"
                  cellRender={({ data }) => (
                    <Button
                      variant="info"
                      size="sm"
                      onClick={() => handleProductSelect(data)}
                    >
                      Select
                    </Button>
                  )}
                /> */}
              </DataGrid>
            </div>
            {products.length === 0 && (
              <div className="text-center py-4">
                <p className="text-muted">No products found.</p>
              </div>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <div className="text-muted">
          {selectedProductKeys.length > 0 && (
            <span>{selectedProductKeys.length} product(s) selected</span>
          )}
        </div>
        <div>
          <Button  onClick={onHide} className="me-2 add-btn">
            Cancel
          </Button>
          {selectedProductKeys.length > 0 && onSelectMultipleProducts && (
            <Button 
             className="submit-btn"
              onClick={handleAddSelectedProducts}
            >
              Add Selected ({selectedProductKeys.length})
            </Button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};